import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  ButtonGroup,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
  UncontrolledTooltip,
} from 'reactstrap';
import ListTableRow from 'components/Table/ListTableRow';
import { BiMoviePlay } from 'react-icons/bi';
import { AiOutlineAudio, AiOutlineFileUnknown } from 'react-icons/ai';
import { FaRegFileAlt, FaRegImage } from 'react-icons/fa';
import { GoFileZip } from 'react-icons/go';
import { Download, Eye, Trash } from 'react-feather';
import { formatHHmmDDMMYYYY } from 'helpers/format-time';
import {
  ASSIGNMENT_STATUS_COLOR,
  ASSIGNMENT_STATUS_LABEL,
  ASSIGNMENT_STATUS_LABEL_TEST,
  DEFAULT_IMAGE,
  UNIT_STATUS,
  USER_ROLES,
} from 'constants/constants';
import { downloadFile, getFileIcon, parseHtml } from 'helpers';
import { useUnit } from 'hooks/units/index';
import styles from 'styles/Course.module.scss';
import FooterTableCustom from 'components/Table/FooterTableCustom';
import { bytesToSize } from 'helpers/number';
import unitsApi from 'api/unitsApi';
import { showToastSuccess } from '@core/components/toastify/ToastTypes';
import classnames from 'classnames';
import { browserName } from 'react-device-detect';
import { useViewMode } from 'hooks';
import ModalTestAnswer from 'modules/Report/Tests/ModalDetail';
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
import { getColor } from 'store/settings';
import LoadingOverlay from 'react-loading-overlay';
import { fetchUnitAsync } from 'store/units/index';
import { Popover } from 'antd';
import styled from '@emotion/styled';
import ImageLoader from 'components/Image';

const SUBMISSION_TYPE = {
  TEXT: 'Text',
  UPLOAD: 'Upload',
};

const ATAG = styled.a`
  :hover {
    text-decoration: underline;
  }
`;

const TrackingResultAssignment = (props) => {
  const {
    tracking,
    fetchData,
    isBusy,
    showOnLoading,
    type,
    assignment,
    getSubmissions,
  } = props;
  const [selected, setSelected] = useState(undefined);
  const dispatch = useDispatch();
  const [isLazyLoad, setIsLazyLoad] = useState(false);
  const unitSelected = useUnit();
  const [testSubmission, setTestSubmission] = useState(null);
  const viewMode = useViewMode();
  const colorStatus = useSelector(getColor);
  async function downLoadFile(file) {
    try {
      setIsLazyLoad(true);

      await downloadFile(file?.path, file?.originalname);
      setIsLazyLoad(false);
    } catch (error) {}
  }
  const toggle = () => setSelected(undefined);

  const deleteItem = async (id) => {
    let array = [...selected?.result?.file];
    array = array
      .map((dt) => {
        if (dt?._id !== id) {
          return dt._id;
        }
      })
      .filter((id) => id !== undefined);
    let obj = { ...selected };
    obj.result.file = array;
    obj.deletedFileId = id;
    const response = await unitsApi.updateTrackingFileDelete(
      selected?._id,
      obj,
    );
    if (response) {
      dispatch(fetchUnitAsync(unitSelected?._id));
      fetchData();
      toggle();
      showToastSuccess('Deleted successfully');
    }
  };

  const deleteHistory = async (id) => {
    if (id) {
      try {
        let status;
        if (id) {
          await Swal.fire({
            title: 'Are you sure?',
            text: 'You want to delete',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: colorStatus,
            cancelButtonColor: 'secondary',
            confirmButtonText: 'Ok',
          })?.then((result) => {
            if (result.isConfirmed) {
              status = result.isConfirmed;
            }
          });
          if (status === true) {
            const response = await unitsApi.deleteHistory(id);
            if (response) {
              fetchData();
              getSubmissions();
              toggle();
              showToastSuccess('Deleted successfully');
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  if (
    !showOnLoading &&
    !tracking?.data?.length &&
    tracking?.currentPage === 1
  ) {
    return null;
  }
  const thead =
    type == 'TEST'
      ? [
          {
            param: '',
            name: 'Date & Time of submission',
            whiteSpace: 'nowrap',
            style: { width: 80 },
          },
          // {
          //   param: '',
          //   name: 'Type of submission',
          //   whiteSpace: 'nowrap',
          //   style: { width: 160 },
          // },
          {
            param: '',
            name: 'View detail',
            whiteSpace: 'nowrap',
            style: { width: 80 },
            center: true,
          },
          {
            param: '',
            name: ' Users',
            style: { width: 170 },
          },
          {
            param: '',
            name: 'Comment',
            style: { width: 100 },
          },
          {
            param: '',
            name: 'Status',
            style: { width: 100 },
          },
          viewMode !== 'LEARNER' && {
            param: '',
            name: 'Action',
            style: { width: 80 },
          },
        ]
      : [
          {
            param: '',
            name: 'Date & Time of submission',
            whiteSpace: 'nowrap',
            style: { width: 200 },
          },
          {
            param: '',
            name: 'Type of submission',
            whiteSpace: 'nowrap',
            style: { width: 160 },
          },
          {
            param: '',
            name: 'Number of document',
            whiteSpace: 'nowrap',
            style: { width: 200 },
          },
          {
            param: '',
            name: ' View detail',
            whiteSpace: 'nowrap',
            style: { width: 160 },
            center: true,
          },
          {
            param: '',
            name: ' Users',
            style: { width: 170 },
          },
          {
            param: '',
            name: 'Comment',
            style: { width: 130 },
          },
          {
            param: '',
            name: 'Status',
            style: { width: 100 },
          },
          viewMode !== 'LEARNER' && {
            param: '',
            name: 'Action',
            style: { width: 80 },
          },
        ];

  return (
    <div className="overflow-x-auto mt-1">
      <Table className="table-header-custom" responsive>
        <thead>
          <tr>
            {thead.map(
              (item) =>
                item && (
                  <th
                    key={item.name}
                    style={item.style || {}}
                    className={`${
                      item?.center ? ' text-center' : ' text-left'
                    } cursor-pointer`}
                  >
                    {item.name}
                    {item.param && (
                      <span>
                        <ChevronDown size={16} />
                      </span>
                    )}
                  </th>
                ),
            )}
          </tr>
        </thead>
        <tbody>
          <ListTableRow isBusy={isBusy} col={6} length={tracking?.data?.length}>
            {tracking?.data?.map((item, index) => (
              <tr
                key={index}
                className={classnames(
                  item?.status === 'DELETED' ? 'tracking-data-delete' : null,
                  styles[
                    item?.status === 'DELETED' ? 'tracking-data-delete' : null
                  ],
                )}
              >
                <td>{formatHHmmDDMMYYYY(item?.createdAt)}</td>
                {item?.type !== 'TEST' && (
                  <td className="text-left">
                    {item?.result?.file?.length || item?.result?.file?._id
                      ? SUBMISSION_TYPE.UPLOAD
                      : SUBMISSION_TYPE.TEXT}
                  </td>
                )}
                {item?.type !== 'TEST' && (
                  <td className="text-center">
                    {/* {item?.result?.file?._id
                          ? 1
                          : item?.result?.file?.length
                          ? item?.result?.file?.length
                          : '--'} */}
                    {item?.result?.attachment?.length ||
                    item?.result?.attachment?._id
                      ? item?.result?.attachment?._id
                        ? 1
                        : item?.result?.attachment?.length
                        ? item?.result?.attachment?.length
                        : '--'
                      : item?.result?.attachment?._id
                      ? 1
                      : item?.result?.file?.length
                      ? item?.result?.file?.length
                      : '--'}
                  </td>
                )}

                <td className="text-center">
                  <ButtonGroup>
                    <span
                      style={{
                        cursor:
                          item?.status !== 'DELETED'
                            ? 'cursor-pointer'
                            : 'no-cursor',
                      }}
                      id={`id-view-${item?._id}${index}`}
                      onClick={() =>
                        item?.type == 'TEST'
                          ? setTestSubmission(item)
                          : item?.status === 'DELETED'
                          ? null
                          : setSelected(item)
                      }
                    >
                      <Eye size={15} />
                      {item?.status !== 'DELETED' && (
                        <UncontrolledTooltip
                          placement="top"
                          className="d-md-block d-none"
                          target={`id-view-${item?._id}${index}`}
                        >
                          View
                        </UncontrolledTooltip>
                      )}
                    </span>
                  </ButtonGroup>
                </td>

                <td className="text-left">
                  {item?.changer?.fullName
                    ? item?.changer?.fullName
                    : item?.user?.fullName}
                </td>
                <td className="text-left">
                  <p className={classnames('text-break', styles[''])}>
                    {item?.result?.comment?.value
                      ? item?.result?.comment?.value
                      : item?.result?.comment
                      ? item?.result?.comment
                      : '--'}
                  </p>
                </td>

                <td
                  className="text-left"
                  style={{
                    color:
                      ASSIGNMENT_STATUS_COLOR[
                        item?.status === 'FAILED' ? 'NOTPASSED' : item?.status
                      ],
                  }}
                >
                  {item?.status
                    ? item?.type === 'TEST'
                      ? ASSIGNMENT_STATUS_LABEL_TEST[
                          typeof item?.result?.grade === 'object' &&
                          item?.status === 'COMPLETED'
                            ? 'GRADED'
                            : item?.status === 'FAILED'
                            ? 'NOTPASSED' // Changed to a valid key 'NOTPASSED'
                            : item?.status === UNIT_STATUS.PENDING &&
                              item?.unit?.config?.manualMarking?.status
                            ? 'WAITING_FOR_REVIEW'
                            : item?.status
                        ]
                      : ASSIGNMENT_STATUS_LABEL[item?.status]
                    : null}
                </td>
                {viewMode !== 'LEARNER' && (
                  <td key={item._id}>
                    <div>
                      <Button.Ripple
                        className="btn-icon px-05 py-05"
                        color="flat-dark"
                        id={`id-delete-${item?._id}`}
                        onClick={() => deleteHistory(item?._id)}
                      >
                        <Trash size={15} />
                        <UncontrolledTooltip
                          className="d-md-block d-none"
                          placement="top"
                          target={`id-delete-${item?._id}`}
                        >
                          Delete
                        </UncontrolledTooltip>
                      </Button.Ripple>
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </ListTableRow>
        </tbody>
      </Table>
      <FooterTableCustom
        pageCount={tracking?.totalPage}
        currentPage={tracking?.currentPage}
        currentItem={tracking?.data?.length}
        totalItems={tracking?.totalItems}
        showInputSearch={false}
        onChange={fetchData}
        preventFirstLoad
      />
      {selected?._id ? (
        <LearnerAnswer
          selected={selected}
          downLoadFile={downLoadFile}
          toggle={toggle}
          isLazyLoad={isLazyLoad}
          isBusy={isBusy}
        />
      ) : null}

      {testSubmission?._id && (
        <ModalTestAnswer
          open={!!testSubmission?._id}
          toggle={() => setTestSubmission(null)}
          data={testSubmission}
          isHistory={true}
          isSubmission={true}
          assignment={assignment}
          showLabelAlways={viewMode === USER_ROLES.LEARNER ? false : true}
        />
      )}
    </div>
  );
};

export default TrackingResultAssignment;

export const LearnerAnswer = ({
  selected,
  toggle,
  downLoadFile,
  isLazyLoad,
  isBusy,
}) => {
  const viewMode = useViewMode();

  return (
    <Modal isOpen={!!selected?._id} toggle={toggle} size="lg" centered={true}>
      <ModalHeader
        className={styles['modal-grade-submission__header']}
        toggle={toggle}
      >
        <div className="flexRow justify-space-between align-items-center">
          <span className="sub-heading_text_title">Learner's answer</span>
        </div>
      </ModalHeader>
      <ModalBody>
        {selected?.result?.content && (
          <p
            className="overflow-x-auto"
            style={{
              overflowWrap: 'break-word',
            }}
          >
            {parseHtml(selected?.result?.content)}
          </p>
        )}
        {selected?.result?.attachment?._id ||
        selected?.result?.attachment?.length ? (
          <div className="overflow-x-auto">
            <LoadingOverlay
              active={isLazyLoad}
              spinner
              styles={{
                overlay: (base) => ({
                  ...base,
                  background: 'rgb(187 181 181 / 50%)',
                  zIndex: 10,
                  top: 7,
                }),
              }}
            >
              <Table className="table-header-custom " responsive>
                <thead>
                  <tr>
                    <th className="text-center">Name</th>
                    <th className="text-center">Size</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <ListTableRow
                    isBusy={isBusy}
                    col={4}
                    length={
                      selected?.result?.attachment?._id
                        ? 1
                        : selected?.result?.attachment?.length
                    }
                  >
                    {Array.isArray(selected?.result?.attachment) &&
                      selected?.result?.attachment?.map((item, index) => {
                        const { Icon, type, extension } = getFileIcon(
                          item?.pathView || item?.path,
                          item?.mimetype,
                        );
                        return (
                          <tr key={index}>
                            <td>
                              {/* <Thumbnail
                                src={item?.pathView || item?.path}
                                type={type}
                                id={item?._id}
                                extension={extension}
                              > */}
                              <div className="mx-0 d-flex  align-items-center">
                                <section className="d-flex align-items-center mr-05">
                                  {<Icon size={25} />}
                                </section>
                                <section className="px-0 line-clamp">
                                  {/* <ATAG
                                      className=" text-start text-truncate"
                                      href={item?.pathView || item?.path || '/'}
                                      target="_blank"
                                    >
                                      {item?.originalname}
                                    </ATAG> */}
                                  {item?.originalname}
                                </section>
                              </div>
                              {/* </Thumbnail> */}
                            </td>
                            <td className="text-center">
                              {bytesToSize(item?.size)}
                            </td>
                            <td className="text-center">
                              <Button.Ripple
                                className="btn-icon px-05 py-05"
                                color="flat-dark"
                                id={`id-${item?._id}-${index}`}
                                onClick={() => downLoadFile(item)}
                              >
                                <Download size={15} />
                                <UncontrolledTooltip
                                  placement="top"
                                  target={`id-${item?._id}-${index}`}
                                >
                                  Download
                                </UncontrolledTooltip>
                              </Button.Ripple>
                            </td>
                          </tr>
                        );
                      })}
                    {selected?.result?.attachment?._id ? (
                      <>
                        {(() => {
                          const { Icon, type, extension } = getFileIcon(
                            selected?.result?.attachment?.pathView ||
                              selected?.result?.attachment?.path,
                            selected?.result?.attachment?.mimetype,
                          );

                          return (
                            <tr>
                              <td className="">
                                {/* <Thumbnail
                                  src={
                                    selected?.result?.attachment?.pathView ||
                                    selected?.result?.attachment?.path
                                  }
                                  type={type}
                                  id={selected?.result?.attachment?._id}
                                  extension={extension}
                                > */}
                                <div className="mx-0 d-flex  align-items-center">
                                  <section className="d-flex align-items-center mr-05">
                                    {<Icon size={25} />}
                                  </section>
                                  <section className="px-0 line-clamp">
                                    {/* <ATAG
                                        className=" text-start text-truncate"
                                        href={
                                          selected?.result?.attachment
                                            ?.pathView ||
                                          selected?.result?.attachment?.path ||
                                          '/'
                                        }
                                        target="_blank"
                                      >
                                        {
                                          selected?.result?.attachment
                                            ?.originalname
                                        }
                                      </ATAG> */}
                                    {selected?.result?.attachment?.originalname}
                                  </section>
                                </div>
                                {/* </Thumbnail> */}
                              </td>
                              <td className="text-center">
                                {bytesToSize(
                                  selected?.result?.attachment?.size,
                                )}
                              </td>
                              <td className="text-center">
                                <Button.Ripple
                                  className="btn-icon px-05 py-05"
                                  color="flat-dark"
                                  id={`id-${selected?.result?.attachment?._id}`}
                                  onClick={() =>
                                    downLoadFile(selected?.result?.attachment)
                                  }
                                >
                                  <Download size={15} />
                                  <UncontrolledTooltip
                                    placement="top"
                                    target={`id-${selected?.result?.file?._id}`}
                                  >
                                    Download
                                  </UncontrolledTooltip>
                                </Button.Ripple>
                              </td>
                            </tr>
                          );
                        })()}
                      </>
                    ) : null}
                  </ListTableRow>
                </tbody>
              </Table>
            </LoadingOverlay>
          </div>
        ) : selected?.result?.file?._id || selected?.result?.file?.length ? (
          <div className="overflow-x-auto">
            <LoadingOverlay
              active={isLazyLoad}
              spinner
              styles={{
                overlay: (base) => ({
                  ...base,
                  background: 'rgb(187 181 181 / 50%)',
                  zIndex: 10,
                  top: 7,
                }),
              }}
            >
              <Table className="table-header-custom " responsive>
                <thead>
                  <tr>
                    <th className="text-center">Name</th>
                    <th className="text-center">Size</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <ListTableRow
                    isBusy={isBusy}
                    col={4}
                    length={
                      selected?.result?.file?._id
                        ? 1
                        : selected?.result?.file?.length
                    }
                  >
                    {Array.isArray(selected?.result?.file) &&
                      selected?.result?.file?.map((item, index) => {
                        const { Icon, type, extension } = getFileIcon(
                          item?.pathView || item?.path,
                          item?.mimetype,
                        );

                        let pathUrl = (item?.pathView || item?.path).includes(
                          process.env.NEXT_PUBLIC_DOMAIN_IMG_HOST,
                        )
                          ? item?.pathView || item?.path
                          : item?.pathView || item?.path
                          ? process.env.NEXT_PUBLIC_DOMAIN_IMG_HOST.concat(
                              `/${item?.pathView || item?.path}`,
                            )
                          : '/';

                        return (
                          <tr key={index}>
                            <td
                              className="cursor-default-im"
                              data-th
                              title={item?.originalname}
                            >
                              {/* <Thumbnail
                                src={pathUrl}
                                type={type}
                                id={item?._id}
                                extension={extension}
                              >
                                <div className="mx-0 d-flex  align-items-center">
                                  <section className="d-flex align-items-center mr-05">
                                    {<Icon size={25} />}
                                  </section>
                                  <section className="px-0 line-clamp">
                                    <ATAG
                                      className=" text-start text-truncate"
                                      href={pathUrl}
                                      target="_blank"
                                    >
                                      {item?.originalname}
                                    </ATAG>
                                  </section>
                                </div>
                              </Thumbnail> */}

                              <div className="mx-0 d-flex  align-items-center">
                                <section className="d-flex align-items-center mr-05">
                                  {<Icon size={25} />}
                                </section>
                                <section className="px-0  ellipsis-dot">
                                  {item?.originalname}
                                </section>
                              </div>
                            </td>
                            <td className="text-center cursor-default-im">
                              {bytesToSize(item?.size)}
                            </td>
                            <td className="text-center cursor-default-im">
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                }}
                              >
                                <div>
                                  <Button.Ripple
                                    className="btn-icon px-05 py-05"
                                    color="flat-dark"
                                    id={`id-${item?._id}-${index}`}
                                    onClick={() => downLoadFile(item)}
                                  >
                                    <Download size={15} />
                                    <UncontrolledTooltip
                                      placement="top"
                                      target={`id-${item?._id}-${index}`}
                                    >
                                      Download
                                    </UncontrolledTooltip>
                                  </Button.Ripple>
                                </div>
                                {viewMode !== 'LEARNER' && (
                                  <div>
                                    <Button.Ripple
                                      className="btn-icon px-05 py-05"
                                      color="flat-dark"
                                      id={`id-delete-${item?._id}`}
                                      onClick={() => deleteItem(item?._id)}
                                    >
                                      <Trash size={15} />
                                      <UncontrolledTooltip
                                        placement="top"
                                        target={`id-delete-${item?._id}`}
                                      >
                                        Delete
                                      </UncontrolledTooltip>
                                    </Button.Ripple>
                                  </div>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    {selected?.result?.file?._id ? (
                      <>
                        {(() => {
                          const { Icon, type, extension } = getFileIcon(
                            selected?.result?.file?.pathView ||
                              selected?.result?.file?.path,
                            selected?.result?.file?.mimetype,
                          );

                          return (
                            <tr>
                              <td
                                className="cursor-default-im"
                                data-th
                                title={selected?.result?.file?.originalname}
                              >
                                {/* <Thumbnail
                                  src={
                                    selected?.result?.file?.pathView ||
                                    selected?.result?.file?.path
                                  }
                                  type={type}
                                  id={selected?.result?.file?._id}
                                  extension={extension}
                                > */}
                                <div className="mx-0 d-flex  align-items-center">
                                  <section className="d-flex align-items-center mr-05">
                                    {<Icon size={25} />}
                                  </section>
                                  <section className="px-0 ellipsis-dot">
                                    {/* <ATAG
                                        className=" text-start text-truncate"
                                        href={
                                          selected?.result?.file?.pathView ||
                                          selected?.result?.file?.path ||
                                          '/'
                                        }
                                        target="_blank"
                                      >
                                        {selected?.result?.file?.originalname}
                                      </ATAG> */}
                                    {selected?.result?.file?.originalname}
                                  </section>
                                </div>
                                {/* </Thumbnail> */}
                              </td>
                              <td className="text-center cursor-default-im">
                                {bytesToSize(selected?.result?.file?.size)}
                              </td>
                              <td className="text-center cursor-default-im">
                                <Button.Ripple
                                  className="btn-icon px-05 py-05"
                                  color="flat-dark"
                                  id={`id_${selected?.result?.file?._id}`}
                                  onClick={() =>
                                    downLoadFile(selected?.result?.file)
                                  }
                                >
                                  <Download size={15} />
                                  <UncontrolledTooltip
                                    placement="top"
                                    target={`id_${selected?.result?.file?._id}`}
                                  >
                                    Download
                                  </UncontrolledTooltip>
                                </Button.Ripple>
                              </td>
                            </tr>
                          );
                        })()}
                      </>
                    ) : null}
                  </ListTableRow>
                </tbody>
              </Table>
            </LoadingOverlay>
          </div>
        ) : null}
      </ModalBody>
    </Modal>
  );
};

export const Thumbnail = ({ src, children, type, id, extension }) => {
  const [visible, setVisible] = useState(false);
  const SUPPORTED_VIDEO_FORMATS = new Map([
    ['Chrome', ['mp4', 'webm', 'ogg']],
    ['Firefox', ['mp4', 'webm', 'ogv']],
    ['Safari', ['mp4']],
    ['Edge', ['mp4', 'webm']],
  ]);

  switch (type) {
    case 'VIDEO':
      const supportedFormats = SUPPORTED_VIDEO_FORMATS.get(browserName) ?? [];
      return supportedFormats.includes(extension) ? (
        <Popover
          zIndex={1060}
          placement="left"
          content={<VideoContent src={src} visible={visible} />}
          title="Preview"
          trigger="hover"
          onVisibleChange={setVisible}
          id={id}
        >
          {children}
        </Popover>
      ) : (
        children
      );

    case 'IMAGE':
      return (
        <Popover
          zIndex={1060}
          placement="left"
          content={
            <ImageLoader
              className="home__list-course--thumbnail"
              src={src || DEFAULT_IMAGE}
              alt={src}
              width={400}
              height={400}
              style={{
                objectFit: 'contain',
              }}
            />
          }
          title="Preview"
          trigger="hover"
          onVisibleChange={setVisible}
          id={id}
        >
          {children}
        </Popover>
      );

    default:
      return children;
  }
};

const VideoContent = ({ src, visible }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      if (visible) {
        videoRef.current.play();
      } else {
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
      }
    }
  }, [visible]);

  return (
    <div style={{ width: 400, aspectRatio: 1 }}>
      {src && (
        <video
          ref={videoRef}
          src={src}
          crossOrigin="anonymous"
          loop
          style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
        />
      )}
    </div>
  );
};
